/** Подключение к комнате по коду — вручную или по ссылке-приглашению. */
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useJoinRoom } from "../api/queries";
import { Spinner } from "../components/ui";

export function JoinPage() {
  const { t } = useTranslation();
  const { joinCode: codeFromLink } = useParams<{ joinCode?: string }>();
  const navigate = useNavigate();
  const joinRoom = useJoinRoom();

  const [code, setCode] = useState(codeFromLink?.toUpperCase() ?? "");
  const [error, setError] = useState<string | null>(null);

  const join = (value: string) => {
    setError(null);
    // Ссылка ведёт в комнату, а не в партию: комната живёт дольше игры, и
    // приглашённый попадает в компанию, а не в конкретный квест. Если она уже
    // играет — сразу в игру, иначе в каталог, где комната видна в шапке.
    joinRoom.mutate(value.trim().toUpperCase(), {
      onSuccess: (room) => {
        navigate(room.currentSessionId ? `/play/${room.currentSessionId}` : "/quests", {
          replace: true,
        });
      },
      onError: (err) => setError(err instanceof Error ? err.message : t("join.failed")),
    });
  };

  // По ссылке-приглашению подключаемся сразу, без лишнего клика.
  useEffect(() => {
    if (codeFromLink) join(codeFromLink);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codeFromLink]);

  if (codeFromLink && joinRoom.isPending) {
    return <Spinner label={t("join.connecting")} />;
  }

  return (
    <div className="mx-auto max-w-md py-8">
      <div className="panel p-7">
        <h1 className="font-sans text-3xl text-ink-50">{t("join.title")}</h1>
        <p className="mt-1.5 text-sm text-ink-400">
          {t("join.lead")}
        </p>

        <form
          className="mt-6 space-y-4"
          onSubmit={(event) => {
            event.preventDefault();
            if (code.trim()) join(code);
          }}
        >
          <input
            className="field text-center tabular-nums text-2xl uppercase tracking-[0.3em]"
            placeholder="XXXXXX"
            maxLength={6}
            value={code}
            onChange={(event) => setCode(event.target.value.toUpperCase())}
          />

          {error && <p className="text-sm text-rust">{error}</p>}

          <button
            type="submit"
            className="btn-primary w-full"
            disabled={code.trim().length < 4 || joinRoom.isPending}
          >
            {joinRoom.isPending ? t("join.joining") : t("join.submit")}
          </button>
        </form>
      </div>
    </div>
  );
}
